// redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Modal, Card, Space, Row, Col } from "antd";
import {
  showAppModal,
  fetchCategory,
  fetchCollaboration,
  getFollowedCategories,
  fetchCollaborationSliders,
  checkCategoryFlags,
} from "~/redux/actions/app";
import { fetchPostList } from "~/redux/actions/post";

// views
import SiteLayout from "~/components/layout/SiteLayout";
import AppMobileNav from "~/components/app/AppMobileNav";
import NewPostCard from "~/components/sider/NewPostCard";
import CategoryTagNavs from "~/components/header/CategoryTagNavs";
import SiderPrimary from "~/components/sider/SiderPrimary";
import PostList from "~/components/post/PostList";
import CategoryCard from "~/components/sider/CategoryCard";
import CitySwiper from "~/components/cities/CitySwiper";
import CollaborationTags from "~/components/collaborations/CollaborationTags";

// utils
import _ from "lodash";
import { getCookie } from "~/utils/cookie";
import { decodeTags } from "~/utils/post";
import { extractDescriptionForPostList } from "~/utils/seo";
import { useEffect } from "react";
import { useRouter } from "next/router";

const CollaborationHomePage = (props) => {
  const router = useRouter();
  const { query } = router;
  const {
    category,
    postList,
    collaboration,
    categoryFlags,
    sliders,
    token,
    user,
  } = props;

  // 用户登录后，获取共学共创信息
  useEffect(() => {
    props.fetchCollaboration(props.token, query.category);
  }, [token]);

  useEffect(() => {
    if (query.showQrcode) {
      props.showAppModal("CollaborationQrcodeModal");
      delete query["showQrcode"];
      router.replace({
        pathname: router.pathname,
        query,
      });
    }
  }, [query.showQrcode]);

  // 判定用户是否在版块拥有角色
  const hasRole = user && _.intersection(user.roles, category.roles).length > 0;
  const canPost =
    categoryFlags && categoryFlags.followed.includes(category.hashid);

  const showFollowCategoryModal = () => {
    Modal.info({
      title: "请先关注该版块",
      content: (
        <div>
          <p>关注后即可在该版块发帖。</p>
        </div>
      ),
    });
  };

  const showNoRoleModal = () => {
    Modal.info({
      title: "您没有权限在该版块发帖",
      content: (
        <div>
          <p>您没有权限在该版块发帖，如需发帖，请联系管理员</p>
        </div>
      ),
    });
  };

  const handlePostClick = () => {
    if (token) {
      if (!hasRole) {
        showNoRoleModal();
        return;
      }
      if (!canPost) {
        showFollowCategoryModal();
        return;
      }
    } else {
      props.showAppModal("PhoneSigninModal");
    }
  };

  const pageHeader = collaboration && sliders.length > 0 && (
    <div className="city-details-wrapper">
      <CitySwiper images={sliders} />
      <div className="city-details">
        <div className="flex align-items-center">
          <div className="collaboration-name">
            {collaboration.category.name}
          </div>
          {sliders && <CollaborationTags collaboration={collaboration} />}
        </div>
      </div>
    </div>
  );

  const newPostCard = (
    <div className="cursor-pointer" onClick={handlePostClick}>
      <NewPostCard
        category={category}
        className={!canPost && "pointer-events-none"}
        hideNewJob
      />
    </div>
  );

  return (
    <SiteLayout
      pageTitle={category.name}
      pageHeader={pageHeader}
      pageSider={
        <div>
          {newPostCard}
          <CategoryCard category={category} />
          <SiderPrimary />
        </div>
      }
      description={extractDescriptionForPostList(postList.posts)}
    >
      <Row>
        <Col xs={24} sm={24} md={0}>
          <AppMobileNav />
        </Col>
      </Row>

      <Card>
        <CategoryTagNavs category={category} />
      </Card>

      <PostList postList={postList} sort={props.sort} />
    </SiteLayout>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
  user: state.user.user,
  collaboration: state.app.collaboration,
  categoryFlags: state.app.flags,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchCollaboration,
      getFollowedCategories,
      showAppModal,
    },
    dispatch
  );

CollaborationHomePage.getInitialProps = async (ctx) => {
  const { query } = ctx;

  // 加载首页的所有版块
  const category = await fetchCategory(query.category);

  // 加载首页的帖子列表
  const tags = decodeTags(query.tags);
  const cookieSort = getCookie("sort", ctx.req);
  const sort = query.sort || cookieSort;
  const page = parseInt(query.page) || 1;
  const postList = await fetchPostList({
    sort,
    page,
    tags,
    category: query.category,
  });

  // 加载共学的轮播
  const sliders = await fetchCollaborationSliders({
    kind: "collaboration",
    listed: "",
    category_id: query.category,
  });

  return {
    sliders,
    category,
    postList,
    tags,
    sort,
    page,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CollaborationHomePage);
